import { render } from "./TrustBox.vue?vue&type=template&id=ceba7084"
import script from "./TrustBox.vue?vue&type=script&lang=js"
export * from "./TrustBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__